import { render, staticRenderFns } from "./SettingsView.vue?vue&type=template&id=145e4e02&scoped=true&"
import script from "./SettingsView.vue?vue&type=script&lang=js&"
export * from "./SettingsView.vue?vue&type=script&lang=js&"
import style0 from "./SettingsView.vue?vue&type=style&index=0&id=145e4e02&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145e4e02",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
